import axiosInstance from 'integration/api/axiosInstance';
import {
  CommonEntitiesListResponse,
  PatientResponseDto,
} from '@docbay/schemas';
import { fetchPatientsProps } from 'common/types/patients';

/**
 * Patients API service.
 */
export const PatientsApi = {
  /**
   * Fetches a list of patients with the specified filtering parameters.
   *
   * @param params - Filtering parameters for fetching patients.
   * @returns A promise that resolves to the response containing the list of patients.
   */
  fetchPatients: (params: fetchPatientsProps) =>
    axiosInstance.get<CommonEntitiesListResponse<PatientResponseDto>>(
      '/saas/users-management/patients',
      {
        params,
      },
    ),
};
